import { render } from "./FullPopup.vue?vue&type=template&id=148452b1&lang=pug"
import script from "./FullPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./FullPopup.vue?vue&type=script&setup=true&lang=js"

import "./FullPopup.vue?vue&type=style&index=0&id=148452b1&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__